module.exports = __webpack_public_path__ + "common/tp-featured5-7394e2fed92c14977ff959454912061b.svg";